import React from 'react';
import { STATUS_COLORS } from '@/utils/constants';
import {snakeToHuman} from "@/utils/formatters.ts";

interface StatusBadgeProps {
    status: string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
                                                            status,
                                                            className = '',
                                                            size = 'md'
                                                        }) => {
    const statusKey = status.toLowerCase() as keyof typeof STATUS_COLORS;
    const colorClasses = STATUS_COLORS[statusKey] || STATUS_COLORS.default;

    return (
        <span
            className={`inline-flex items-center ${sizeClasses[size]} font-semibold rounded-full ${colorClasses} ${className}`}
        >
      {snakeToHuman(status)}
    </span>
    );
};

export default StatusBadge;
